<template>
  <d-container fluid class="main-content-container px-4">
    <div class="page-header row no-gutters py-4">
      <div class="d-flex justify-content-between no-gutters col-12">
        <div class="col-3 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">Airport</span>
          <h3 class="page-title">Overview</h3>
        </div>
        <div class="d-flex justify-content-end align-items-end col-9">
          <d-select class="col-2" v-model="country">
            <option selected value="">Select country</option>
            <template v-for="item in countries">
              <option :value="item" >
                {{ item }}
              </option>
            </template>
          </d-select>
          <d-input class="col-6" name='searchField' type="text" v-model="search" placeholder="filter airport by name"></d-input>
          <d-button class="btn btn-primary ml-3 col-2" type="submit" @click="onAddNewAirport" onclick="">Add Airport</d-button>
        </div>
      </div>
    </div>

    <d-card>
      <d-card-body class="p-0">
        <div class="table-responsive">
          <table class="table mb-0">
            <thead class="bg-light">
            <tr>
              <th scope="col" class="border-0">Airport</th>
              <th scope="col" class="border-0" style="width: 150px;">Country</th>
              <th scope="col" class="border-0" style="width: 150px;">Terminals</th>
            </tr>
            </thead>

            <tbody>
            <template v-for="airport in filteredAirportList">
              <tr style="cursor: pointer;" :key="airport.id" @click="onAirportClick(airport.id)">
                <td style="vertical-align: middle;">
                  <strong style="font-size: .9rem;">{{airport.localizedName}}</strong><br>
                  <span style="color: #666;">{{airport.location.address.street}}, {{airport.location.address.city}}, {{airport.location.address.country}}</span>
                </td>
                <td style="vertical-align: middle;">{{airport.location.address.country}}</td>
                <td style="vertical-align: middle;">{{airport.terminals.length}}</td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
  export default {
    methods: {

      onAddNewAirport: function ($event) {
        this.$router.push({
          name: 'airports.create'
        });
      },

      onAirportClick: function ($event) {
        this.$router.push({
          params: {
            id: $event,
          },
          name: 'airports.single',
        });
      },
    },

    computed: {
      filteredAirportList() {
        return this.airports.filter(item => {
          if(this.country !== '' && item.location.address.country === this.country) {
            return item.localizedName.toLowerCase().includes(this.search.toLowerCase());
          } else if(this.country === '') {
            return item.localizedName.toLowerCase().includes(this.search.toLowerCase());
          }
        })
      }
    },

    apollo: {
      load: function () {
        return {
          fetchPolicy: 'no-cache',
          update: function (data) {
            this.airports = data.airports;
            this.countries = [...new Set(this.airports.map(item => item.location.address.country))];
          },
          query: require('../../graphql/GetAirports.gql'),
        };
      },
    },

    data: function () {
      return {
        search: '',
        airports: [],
        countries: [],
        country: ''
      };
    },
  };
</script>

